import isEmpty from 'lodash/isEmpty';
import { getUrlImagePath } from 'common/utilities/utils';
import { IMAGE_SIZE_CONSTANTS, ADD_HOPE_THANK_YOU } from 'common/constants/SharedConstants';
const { ADD_HOPE_THANKYOU_ITEMS } = IMAGE_SIZE_CONSTANTS;

export const getAddHopeThankYouContentData = ({ title = '', content = [], description = '', image = {} }) => {
  const items = content?.map(item => item.fields);
  const imageData = image?.fields;
  if (!isEmpty(items) && imageData && ADD_HOPE_THANK_YOU === title) {
    const goToHomePageBtnText = items[0]?.buttonText;
    const desktopImage = getUrlImagePath(
      imageData?.file?.url,
      ADD_HOPE_THANKYOU_ITEMS.THANKYOU_IMAGE_HEIGHT_DESKTOP,
      ADD_HOPE_THANKYOU_ITEMS.THANKYOU_IMAGE_WIDTH_DESKTOP,
    );
    const mobileImage = getUrlImagePath(
      imageData?.file?.url,
      ADD_HOPE_THANKYOU_ITEMS.THANKYOU_IMAGE_HEIGHT_MOBILE,
      ADD_HOPE_THANKYOU_ITEMS.THANKYOU_IMAGE_WIDTH_MOBILE,
    );
    return {
      pageTitle: title,
      description: description,
      desktopImage: desktopImage,
      mobileImage: mobileImage,
      goToHomePageBtnText: goToHomePageBtnText,
    };
  }
};
